import { createSlice } from '@reduxjs/toolkit';

import { parseResponse } from '@skynet/data-ws-core';
import { actionOnMessage } from '@skynet/data-ws-mm';

import { RetainerOverviewCommands } from './types';
import type { JsonRetainerOverviewSuccess, RetainerOverviewState } from './types';

const allowedCommands = Object.values(RetainerOverviewCommands);

export const initialState: RetainerOverviewState = {
  requestStatus: null,
  error: null,

  exchanges: [],
  balances: null,

  supportedPairs: [],
  supportedExchanges: [],
  prices: [],
  coinGeckoLink: '',
};

const retainerOverviewSlice = createSlice({
  name: 'retainerOverview',
  initialState,
  reducers: {
    /**
     * Marks the request as in-flight. Dispatched by the app when it starts
     * listening for the overview section (the app owns the `listen` action,
     * which this package cannot import).
     */
    setRequestPending: (state) => {
      state.requestStatus = 'pending';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actionOnMessage, (state, action) => {
      const { json, skipProcessing, error } = parseResponse(action.payload, allowedCommands);

      if (skipProcessing || !json) return;

      const { command } = json;

      if (error) {
        state.error = error;
        return;
      }

      if (command === RetainerOverviewCommands.RetainerOverview) {
        const {
          exchanges,
          balances,
          supportedExchanges,
          pairs,
          prices,
          coinGeckoLink,
        }: JsonRetainerOverviewSuccess = json;

        state.exchanges = exchanges;
        state.balances = balances;
        state.supportedExchanges = supportedExchanges;
        state.supportedPairs = pairs;
        state.prices = prices;
        state.coinGeckoLink = coinGeckoLink ?? '';
        state.requestStatus = 'success';
      }
    });
  },
});

export const retainerOverviewActions = { ...retainerOverviewSlice.actions };

export default retainerOverviewSlice.reducer;
